import {Page, Button, Card, Text, ButtonGroup} from "@shopify/polaris";
import React, {useEffect, useState} from "react";
import {Redirect} from "@shopify/app-bridge/actions";
import Http from "../../Lib/Http";
import Stepper from "./Stepper"
import PageDivider from "../../components/PageDivider";
import {Plan} from "../../types";

function GetStarted() {
    const [baseURL, setBaseURL] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);
    const [legacy, setLegacy] = useState(false);
    const [freePlan, setFreePlan] = useState<Plan | null>(null);
    const [paidPlan, setPaidPlan] = useState<Plan | null>(null);

    const goTo = (location: string) => {
        let redirect = Redirect.create(window.app);
        redirect.dispatch(Redirect.Action.APP, '/app' + location);
    }




    useEffect(() => {
    }, []);


    const getShops = () => {
        setLoading(true) ;

        Http.get(`/app/api/v1/shop.json`)
            .then((response) => {
                let shop = response.data.shop
                setLegacy( shop.legacy);
                setLoading(false) ;
                console.log(shop);
                console.log('shop.legacy');

            })
            .catch((error) => {
                console.error('Error fetching data:', error);
                setLoading(false) ;
            });
    };




    return (
        <Page>
            <div style={{paddingBottom:'20px'}}>
                <Stepper currentStep={4}/>
                <Card>
                    <div>
                        <div style={{width: '100%', marginTop: '5px', textAlign: 'center'}}>
                        </div>
                        <div style={{width: '100%', marginTop: '15px', marginBottom: '20px', textAlign: 'center'}}>

                            <Text variant="headingLg" as="h5">
                                Congratulations, you have now installed ESC ‑ Size Charts & Size Guide
                            </Text>
                        </div>
                        <div
                            style={{width: '100%', textAlign: 'center', paddingBottom: '20px'}}
                        >
                            You’re almost ready to go! You’ve joined <br/> <strong>over
                            7,000+</strong> merchants who have now installed Size Matters.
                            <br/>
                        </div>
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <ButtonGroup>
                                <Button variant="primary"  onClick={() => goTo('/charts/new')}>
                                    Create first size chart</Button>
                                <Button onClick={() => goTo('/')}>
                                    Do it later</Button>
                            </ButtonGroup>
                        </div>
                    </div>
                </Card>
            </div>
        </Page>
    );
}

export default GetStarted;
